import {
    $get,
    $post
} from '@/utils/http'
//首页
export default {
    // //轮播图
    // getBannerDEtail(params) {
    //     return $post('/portal/websit/rotationChartManager/getPicById', params)
    // },
    // //轮播图详情页
    // getBannerDEtail(params) {
    //     return $post('/portal/websit/rotationChartManager/getPicById', params)
    // },
    // getcode(params) {
    //     return $post('/portal/websit/rqcode/listRqCode', params)
    // }
    // 获取交易累计统计信息
    tradeStatisticsCumulative(params) {
        return $get('/DoorCarbonTrade/tradeStatisticsCumulative', params)
    },
    // 获取不同类别碳交易数据概览
    tradeStatistics(params) {
        return $get('/DoorCarbonTrade/tradeStatistics', params)
    },
}
